@use '../../../styles/colors' as colors;

.has-border-bottom {
    border-bottom: 1px solid map-get(map-get(colors.$color-pallete, "grey"), "200");
}